var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"Requirements Sourced"}},[_c('requirements',{attrs:{"requirementArr":_vm.requirementOffers}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }